import { create } from "zustand";
import { SidebarV2Store } from "../types/sidebar-v2.type";

const sidebarV2Store = create<SidebarV2Store>((set) => ({
  // Search menu
  search: '',
  setSearch: (newSearch) => set((state) => ({
    ...state,
    search: newSearch
  })),

  // Reveal
  reveal: true,
  setReveal: (newReveal) => set((state) => ({
    ...state,
    reveal: newReveal
  })),

  // Mobile
  showMobile: true,
  setShowMobile: (show) => set((state) => ({
    ...state,
    showMobile: show
  })),
}))

export default sidebarV2Store